/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { saveDescuentoCristal } from "../../../project/services/DescuentoCristalService";
import { DatePicker } from "@mui/x-date-pickers";
import { isNumeric } from "../../../project/utils/utils";
import { isValid, format } from "date-fns";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  porcentajeDescuento: 0,
  fechaVigenciaDesde: null,
  fechaVigenciaHasta: null,
  fechaUltimaCompra: null,
  observaciones: "",
};

const nameItemText = "Descuento de Cristales";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
const DescuentoCristalDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [cristalProductos, setCristalProductos] = useState([]);
  const [valueACCristalProducto, setValueACCristalProducto] = useState({
    id: "",
    label: "",
  });
  const [inputValueACCristalProducto, setInputValueACCristalProducto] =
    useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadCristalProductos();
    if (actionCrud === "new") {
      setValueACCristalProducto(cristalProductos[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueACCristalProducto(itemCrud.cristalProducto);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto");
    if (response.ok) {
      let _response = response.data.data;
      let _cristalProductos = [];
      _response.forEach((item) => {
        _cristalProductos.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_cristalProductos);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaVigenciaDesde = (fecha) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      fechaVigenciaDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaVigenciaHasta = (fecha) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      fechaVigenciaHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaUltimaCompra = (fecha) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      fechaUltimaCompra: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (inputValueACCristalProducto === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Producto",
        });
        setShowMessage(true);
        return;
      }

      if (
        !isNumeric(itemCrudLocal.porcentajeDescuento).toString() ||
        itemCrudLocal.porcentajeDescuento <= 0
      ) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un porcentaje de descuento mayor a 0",
        });
        setShowMessage(true);
        return;
      }

      if (
        itemCrudLocal.fechaVigenciaDesde === null ||
        !isValid(itemCrudLocal.fechaVigenciaDesde)
      ) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar una fecha de vigencia inicial válida",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.fechaVigenciaHasta != null) {
        if (!isValid(itemCrudLocal.fechaVigenciaHasta)) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar una fecha de vigencia final válida",
          });
          setShowMessage(true);
          return;
        }

        if (
          itemCrudLocal.fechaVigenciaDesde > itemCrudLocal.fechaVigenciaHasta
        ) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar un período de fechas de vigencia válido",
          });
          setShowMessage(true);
          return;
        }
      }

      if (itemCrudLocal.fechaUltimaCompra != null) {
        if (!isValid(itemCrudLocal.fechaUltimaCompra)) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar una fecha de última compra válida",
          });
          setShowMessage(true);
          return;
        }

        if (itemCrudLocal.fechaUltimaCompra > new Date()) {
          setMessage({
            severity: "error",
            messageText:
              "La fecha de última compra debe ser menor o igual a la fecha de hoy",
          });
          setShowMessage(true);
          return;
        }
      }
    }
    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {
    let _itemCrud = {
      tipo_articulo: "cristal",
      id_cristal_producto: valueACCristalProducto.id,
      fecha_vigencia_desde: format(itemCrudLocal.fechaVigenciaDesde, "yyyy/MM/dd"),
      fecha_vigencia_hasta: itemCrudLocal.fechaVigenciaHasta ? format(itemCrudLocal.fechaVigenciaHasta, "yyyy/MM/dd") : null,
      fecha_ultima_compra: itemCrudLocal.fechaUltimaCompra ? format(itemCrudLocal.fechaUltimaCompra, "yyyy/MM/dd") : null,
      porcentaje_descuento: Number(itemCrudLocal.porcentajeDescuento),
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveDescuentoCristal(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={10}>
              <Autocomplete
                id="cristalProductos"
                sx={{ width: "100%" }}
                size="small"
                value={
                  valueACCristalProducto && valueACCristalProducto.id
                    ? valueACCristalProducto
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACCristalProducto(newValue);
                }}
                inputValue={inputValueACCristalProducto}
                onInputChange={(event, newInputValue) => {
                  setInputValueACCristalProducto(newInputValue);
                }}
                options={cristalProductos}
                renderInput={(params) => <TextField {...params} label="Producto" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                  maxLength: 3,
                }}
                id="porcentajeDescuento"
                label="Porcentaje de Descuento"
                variant="outlined"
                size="small"
                name="porcentajeDescuento"
                value={itemCrudLocal.porcentajeDescuento}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={4}>
              <DatePicker
                id="fechaVigenciaDesde"
                label="Vigencia desde"
                variant="outlined"
                name="fechaVigenciaDesde"
                value={itemCrudLocal.fechaVigenciaDesde}
                format="dd/MM/yyyy"
                onChange={(newValue) =>
                  handleChangeFechaVigenciaDesde(newValue)
                }
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={4}>
              <DatePicker
                id="fechaVigenciaHasta"
                label="Vigencia hasta"
                variant="outlined"
                name="fechaVigenciaHasta"
                value={itemCrudLocal.fechaVigenciaHasta}
                format="dd/MM/yyyy"
                onChange={(newValue) =>
                  handleChangeFechaVigenciaHasta(newValue)
                }
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={4}>
              <DatePicker
                id="fechaUltimaCompra"
                label="Fecha última compra"
                variant="outlined"
                name="fechaUltimaCompra"
                value={itemCrudLocal.fechaUltimaCompra}
                format="dd/MM/yyyy"
                maxDate={new Date()}
                onChange={(newValue) =>
                  handleChangeFechaUltimaCompra(newValue)
                }
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default DescuentoCristalDialog;
